import React from 'react';

import GoalContainer from 'containers/GoalContainer';

const Name = ({ name = null }) => name;

const GoalName = ({ id }) => <GoalContainer id={id}><Name /></GoalContainer>;

export default GoalName;
